import bem from 'utils/bem';

export const block = bem('try-eddy-at-cancellation-modal');
